import { DynamicFieldModel as DynamicFieldModel, FormModel } from '@ps-gui/ui';
import {
  FieldGroupModel,
  FieldModel,
  SimpleFieldGroupModel,
} from '../../../models/extraction-models/extraction-models';
import { Validators } from '@angular/forms';

export const mapToFormModel = <const T extends FieldModel[] = FieldModel[]>(
  fieldGroup: FieldGroupModel,
): FormModel => {
  const groupIndex = fieldGroup.index * 100;
  // TODO: fix typing to prevent casting to unknown
  // if (fieldGroup.type === 'binary') {
  //   return mapToBinaryFieldGroup(fieldGroup as unknown as BinaryFieldGroupModel<T>, groupIndex);
  // } else if (fieldGroup.type === 'multi') {
  //   return mapToMultiFieldGroup(fieldGroup as unknown as MultiFieldGroupModel<T>, groupIndex);
  // } else {
  return mapToSimpleFieldGroup(fieldGroup as unknown as SimpleFieldGroupModel<T>, groupIndex);
  // }
};

const mapToSimpleFieldGroup = <T extends FieldModel[]>(
  fieldGroup: SimpleFieldGroupModel<T>,
  offset = 0,
): FormModel => {
  return {
    index: fieldGroup.index,
    key: fieldGroup.key,
    type: 'simple',
    label: fieldGroup.label,
    validators: fieldGroup.groupValidators,
    fieldModels: mapToFieldModel(fieldGroup.fieldModels, offset),
  };
};

const mapToFieldModel = (fieldModels: FieldModel[], offset = 0): DynamicFieldModel[] =>
  fieldModels.map(
    (fieldModel) =>
      ({
        ...fieldModel,
        index: offset + fieldModels.length,
        value: fieldModel.defaultValue,
        required: fieldModel.validators?.find(
          (validationConfig) => validationConfig.validator === Validators.required,
        ),
      }) as unknown as DynamicFieldModel,
  );
